const ABOUTS_DOMAIN = 'abouts'

const ABOUTS_KEY = {
  ALL: 'all',
  CURRENT: 'current',
  DATA: 'data'
}

const ABOUTS_ACTION = {
  LOAD_ABOUT: 'LOAD_ABOUT',
  UPDATE_CURRENT: 'UPDATE_CURRENT',
  CREATE_ABOUT: 'CREATE_ABOUT',
  UPDATE_ABOUT: 'UPDATE_ABOUT',
  UPDATE_ABOUT_BIO: 'UPDATE_ABOUT_BIO',
  UPDATE_COVER_MEDIA_ID: 'UPDATE_COVER_MEDIA_ID',
  UPDATE_INSTAGRAM: 'UPDATE_INSTAGRAM',
  UPDATE_TIKTOK: 'UPDATE_TIKTOK',
  UPDATE_TWITTER: 'UPDATE_TWITTER',
  UPDATE_WELCOME_MEDIA_ID: 'UPDATE_WELCOME_MEDIA_ID',
  UPDATE_WELCOME_MEDIA: 'UPDATE_WELCOME_MEDIA',
  UPDATE_WELCOME_MEDIA_TITLE: 'UPDATE_WELCOME_MEDIA_TITLE',
  UPDATE_YEARS_OF_EXPERIENCE: 'UPDATE_YEARS_OF_EXPERIENCE',
  UPDATE_YOUTUBE: 'UPDATE_YOUTUBE',
  UPDATE_MEDIA: 'UPDATE_MEDIA'
}

const ABOUTS_PATH = {
  ALL: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.ALL}`,
  CURRENT: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.CURRENT}`,
  DATA: `${ABOUTS_DOMAIN}.${ABOUTS_KEY.DATA}`
}

const ABOUTS_STATE = {
  [ABOUTS_KEY.ALL]: {
    data: [],
    status: null
  },
  [ABOUTS_KEY.CURRENT]: null,
  [ABOUTS_KEY.DATA]: {}
}

const ABOUTS_ENDPOINT = {
  ABOUT: '/abouts',
  UPDATE_ABOUT: '/abouts/:id'
}

export {
  ABOUTS_DOMAIN,
  ABOUTS_KEY,
  ABOUTS_PATH,
  ABOUTS_STATE,
  ABOUTS_ENDPOINT,
  ABOUTS_ACTION
}
